
import React, { useState, useEffect } from "react";
import { Protected } from "@/components/layout/Protected";
import { Box, Button, Card, CardActions, CardContent, Container, Divider, Grid, Tooltip, Typography } from "@mui/material";
import {Props} from './Salas.type';
import { AddSala } from './components/AddSala/AddSala';
import { AddMesa } from './components/AddMesa/AddMesa';
import { CodigoQR } from './components/CodigoQR/CodigoQR';
import { Popup } from '../Editor/components/Popup/Popup';
import { Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, createTheme, ThemeProvider } from '@mui/material';
import { esES } from '@mui/material/locale';
import DeleteIcon from '@mui/icons-material/Delete';
import { PencilIcon } from "@toolbox/constants/icons";
import EditIcon from '@mui/icons-material/Edit';
import { salas } from '../../service/services/Salas.service';
import { Loading } from '../../components/common/Loading/Loading';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';
import './components/Modal.sass'
import AssignmentIcon from '@mui/icons-material/Assignment';
import { ModalReservas } from "./../Reservas/components/ModalReservas";
// import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { Snackbar, Alert } from '@mui/material';
import QrCodeIcon from '@mui/icons-material/QrCode';
import SettingsIcon from '@mui/icons-material/Settings';
import { ConfigMesa } from "./components/ConfigMesa";

export const Salas: React.FC<Props> = (props:Props): JSX.Element => {

    const [popUp, setPopUp] = React.useState<String>('');
    const [openPopup, setOpenPopup] = React.useState(false);
    const [allSalas, setSalas] = React.useState([]);
    const [loadData,setLoadData] = React.useState<boolean>(false);
    const [selectSala, setSelectSala] = React.useState<any>('');
    const [selectMesa, setSelectMesa] = React.useState<any>('');
    const [mesas, setMesas] = React.useState([]);
    const [textSearch, setTextSearch] = useState<string>("");
    const [filter, setFilter] = useState<Array<any>>([]);
    // eslint-disable-next-line
   const [dataModalSala, setDataModalSala] = useState<any>(false);

   const [showModalConfig, setShowModalConfig] = useState<any>(false);
   const [showModalQr, setShowModalQr] = useState<any>(false);
   const [showModalAddMesa, setShowModalAddMesa] = useState<any>(false);
   const [showModalEditMesa, setShowModalEditMesa] = useState<any>(false);
   const [showModalReserva, setShowModalReserva] = useState<any>(false);

   const [snackBarConfig, setSnackBarConfig] = React.useState<any>({
    open: false,
    severity: 'error',
    message: 'Error',
    autoHideDuration: 3000,
    });

 useEffect(() => {
    if (textSearch) {
       let copyFilters = [];
       copyFilters = mesas.filter(mesa => (mesa?.nombre.toLowerCase().includes(textSearch.toLowerCase()) ) )
       setFilter([...copyFilters])
    }
 }, // eslint-disable-next-line
 [textSearch])

   React.useEffect(() => {
    async function fetch(){
        setLoadData(true);
        await salas.cargarSalas().then((data)=>{
            setSalas(data.salas);
            setLoadData(false);
        });
    }
    fetch();
    },// eslint-disable-next-line
    []);


   const theme = createTheme(
    {
        palette: {
            primary: { main: '#1976D2' },
        },
    },
    esES,
    );

    const deleteSala = async (id)=>{
        setLoadData(true);
        await salas.deleteSala(id);
        cargarSalas();
        setLoadData(false);
    }

    const cargarSalas = async ()=>{
        setLoadData(true);
        await salas.cargarSalas().then((data)=>{
            setSalas(data.salas || []);
            setLoadData(false);
        });
    }

    const cargarMesas = async (id_sala)=>{
        setLoadData(true);
        await salas.cargarMesas(id_sala).then((data)=>{
            setMesas(data.mesas || [])
            setFilter(data.mesas || [])
            setLoadData(false)
           // setFilter(data.mesas)
        });

    }

    const deleteMesa = async (item)=>{
        setLoadData(true);
        if(item.state === 0){
            setSnackBarConfig(prev => ({
                ...prev,
                open: true,
                message: `No se puede eliminar una mesa ocupada`,
            }));
            setLoadData(false);
        }else{
            await salas.deleteMesa(item.id).then(()=>{
                const deleteCant = selectSala.mesas-1
                selectSala.mesas = selectSala.mesas-1;
                setSelectSala(selectSala);
                salas.editSala(selectSala.id,selectSala.nombre, deleteCant, selectSala.state).then(()=>{
                    cargarMesas(selectSala.id);
                    cargarSalas();
                    setLoadData(false);
                });
            });
        }
    }

   //  const funcionSwitch = async (item)=>{
   //      setLoadData(true);
   //      if(item.state === 1){
   //          await salas.editMesaStatus(item.id,0);
   //      }else{
   //          await salas.editMesaStatus(item.id,1);
   //      }
   //      cargarMesas(selectSala.id).then();

   //  }

    const handleLoad = (e) =>{
        if(e === 'editMesa'){
            setOpenPopup(true);
            setPopUp('mesas');
            cargarMesas(selectSala.id);
        }else{
            selectSala.mesas = selectSala.mesas+1;
            setSelectSala(selectSala);
            cargarSalas();
            setOpenPopup(true);
            setPopUp('mesas');
            cargarMesas(selectSala.id);
        }
    }


// const nextPage = (toroute, row) => {
//   history.push(toroute, row);
// };

// const handleChangePage = (event, newPage) => {
//     setPage(newPage);
// };

// const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
// };


   return (
      <Protected>
          {loadData && <Loading/>}
          <Snackbar
            open={snackBarConfig.open}
            autoHideDuration={snackBarConfig.autoHideDuration}
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
            <Alert
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            severity={snackBarConfig.severity}
            variant="filled"
            >
            {snackBarConfig.message}
            </Alert>
        </Snackbar>
         <Container maxWidth='xl' sx={{ mt: 1, mb: 2 }}>
                <Grid container justifyContent='space-between' spacing={2}>
                    <Grid item>
                        <Typography variant='h4' >Gestión de Sala</Typography>
                    </Grid>
                    <Grid item>
                        <Button variant='outlined' style={{textTransform: "capitalize"}}
                        onClick={()=>{
                            setOpenPopup(true);
                            setDataModalSala(false);
                            setPopUp('add');
                        }}
                        >Crear Sala</Button>
                    </Grid>
                </Grid>
                <Divider
                    sx={{ mt: 2 }} />
                <Grid container spacing={1} >
                    <Grid item xs={12}>
                        <Typography variant="body2" sx={{ mt: '20px' }} >
                        {allSalas.length ? `${allSalas.length} registros encontrados` : `0` && !loadData}
                        </Typography>
                    </Grid>
                </Grid>

                {loadData && allSalas.length === 0 &&
                     <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height:'100px'}}>
                     </Box>
                }

            <Grid >
                {allSalas.length !== 0 &&
                <Box sx={{Width: '100%', marginTop:'30px'}}>
                    <TableContainer component={Paper}>
                    <ThemeProvider theme={theme}>
                        <Table aria-label="simple table" size='small'>
                            <TableHead >
                            <TableRow sx={{ bgcolor:'#1976D2'}}>
                                    <TableCell sx={{ color: 'white' }} ><strong>N°</strong></TableCell>
                                    <TableCell sx={{ color: 'white' }} ><strong>Nombre Sala</strong></TableCell>
                                    <TableCell align='center' sx={{ color: 'white' }} ><strong>Empresa</strong></TableCell>
                                    <TableCell align='center' sx={{ color: 'white' }} ><strong>Cantidad de Mesas</strong></TableCell>
                                    <TableCell align='center' sx={{ color: 'white' , minWidth:'8rem', maxWidth:'12rem'}}><strong>Acciones</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {allSalas.length !== 0 &&
                                    allSalas.map((item,index) => (
                                    <TableRow key={item.id}>
                                        <TableCell component="th" scope="row">
                                            {index+1}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {item.nombre.charAt(0).toUpperCase() + item.nombre.slice(1).toLowerCase()}
                                        </TableCell>
                                        <TableCell align='center' component="th" scope="row">
                                            {item.id_empresa}
                                        </TableCell>
                                        <TableCell align='center' component="th" scope="row">
                                            {item.mesas}
                                        </TableCell>
                                    <TableCell align='center'>
                                        <Button color="error"
                                            onClick={()=>{deleteSala(item.id)}}
                                        >
                                            <DeleteIcon />
                                        </Button>
                                        <Button
                                            onClick={() =>  {
                                                setOpenPopup(true);
                                                setPopUp('edit');
                                                setSelectSala(item);
                                            }}
                                        >
                                            <PencilIcon />
                                        </Button>
                                        <Button
                                            onClick={() =>  {
                                                setOpenPopup(true);
                                                setPopUp('mesas');
                                                setTextSearch("")
                                                setSelectSala(item);
                                                cargarMesas(item.id);
                                            }}
                                        >
                                            <TableRestaurantIcon />
                                        </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </ThemeProvider>
                    </TableContainer>
                </Box>
                }
                {!loadData && allSalas.length === 0 &&
                    <Grid container justifyContent="center">
                        <Box sx={{marginTop: '50px'}}>
                            <Grid container justifyContent="center"> <ContentPasteOffIcon className="iconocarrito"/></Grid>
                            <Box sx={{Width: '100%', marginBottom:'30px', textAlign:'center'}}>No hay salas</Box>
                        </Box>
                    </Grid>
                }
            </Grid>
         </Container>

         {popUp === 'add' &&
         <Popup
            largo="sm"
            title = 'Crear Sala'
            openPopup = {openPopup}
            setOpenPopup = {setOpenPopup}
        >
            <AddSala
                closeModal = {() => setOpenPopup(false)}
                onListSala = {cargarSalas}
            />
        </Popup>
         }

        {popUp === 'edit' &&
         <Popup
            largo="sm"
            title = 'Editar Sala'
            openPopup = {openPopup}
            setOpenPopup = {setOpenPopup}
        >
            <AddSala
                sala={selectSala}
                closeModal = {() => setOpenPopup(false)}
                onListSala = {cargarSalas}
            />
        </Popup>
         }

        {popUp === 'mesas' &&
         <Popup
            largo="sm"
            title = {`Mesas de la sala: ${selectSala.nombre.charAt(0).toUpperCase() + selectSala.nombre.slice(1).toLowerCase()}`}
            openPopup = {openPopup}
            setOpenPopup = {setOpenPopup}
        >
            {mesas.length !== 0 &&
                <Box sx={{Width: '100%'}}>
                    <Box /* sx={{display:'flex',flexDirection: 'row-reverse', marginBottom:'15px'}} */ sx={{marginBottom:'15px'}} >
                        <Box>
                            <Button className="boton"
                            variant={'outlined'}
                            onClick={() =>  {
                                setShowModalAddMesa(true);
                                // setPopUp('addMesa');
                            }}
                            >
                                Agregar
                            </Button>
                        </Box>
                    </Box>
                    <Grid container>
                        {
                            mesas.length !== 0 &&
                            filter.map((item,index) => (
                                <Card className={item.state ? 'habilitado' : 'desahabilitado'}>
                                    <CardContent className="border">
                                        <Typography className="text">
                                            {item.nombre.charAt(0).toUpperCase() + item.nombre.slice(1).toLowerCase()}
                                        </Typography>
                                    </CardContent>
                                    <CardActions className="content-icon">

                                        <Button
                                            onClick={()=>{deleteMesa(item);
                                            }}
                                        >
                                            <Tooltip title={"eliminar"}>
                                                <DeleteIcon  className="deleted" color='action'/>
                                            </Tooltip>
                                        </Button>

                                        <Button
                                            onClick={() =>  {
                                                setShowModalEditMesa(true);
                                                // setPopUp('editMesa');
                                                setSelectMesa(item);
                                            }}
                                        >
                                            <Tooltip title={"editar"}>
                                                <EditIcon className="edit"  color='action'/>
                                            </Tooltip>
                                        </Button>

                                        <Button
                                            onClick={() =>  {
                                                setShowModalQr(true);
                                                // setPopUp('QR');
                                                setSelectMesa(item);
                                            }}
                                        >
                                            <Tooltip title={"Ver QR"}>
                                                <QrCodeIcon className="print"  color='action'/>
                                            </Tooltip>
                                        </Button>

                                        <Button
                                            onClick={() =>  {
                                                setShowModalReserva(true);
                                                // setPopUp('reserva');
                                                setSelectMesa(item);
                                            }}
                                        >
                                            <Tooltip title={"Ver Reserva"}>
                                            <AssignmentIcon className="reserva" color="action"/>
                                            </Tooltip>
                                        </Button>

                                        <Button
                                            onClick={() =>  {
                                                setShowModalConfig(true);
                                                // setPopUp('config');
                                                setSelectMesa(item);
                                            }}
                                        >
                                            <Tooltip title={"configuración"}>
                                            <SettingsIcon className="config" color="action"/>
                                            </Tooltip>
                                        </Button>

                                    </CardActions>
                                </Card>
                            )
                        )}
                    </Grid>

                </Box>
            }

            {!loadData && mesas.length === 0 &&
            <Box>
                    <Box sx={{display:'flex',flexDirection: 'row-reverse', marginBottom:'15px'}}>
                        <Button
                        variant={'outlined'}
                        onClick={() =>  {
                            setOpenPopup(true);
                            setPopUp('addMesa');
                        }}
                        >
                            Agregar
                        </Button>
                    </Box>
                    <Grid container justifyContent="center">
                        <Box>
                            <Grid container justifyContent="center"> <ContentPasteOffIcon className="iconocarrito"/></Grid>
                            <Box sx={{Width: '100%', marginBottom:'30px', textAlign:'center'}}>No hay Mesas</Box>
                        </Box>
                    </Grid>
            </Box>
            }
        </Popup>
        }

        {showModalAddMesa &&
            <Popup
                largo="sm"
                title = 'Agregar Mesa'
                openPopup = {showModalAddMesa}
                setOpenPopup = {setShowModalAddMesa}
            >
                <AddMesa
                    sala={selectSala}
                    handleLoad={handleLoad}
                />
            </Popup>
        }
        {showModalEditMesa &&
            <Popup
                largo="sm"
                title = 'Editar Mesa'
                openPopup = {openPopup}
                setOpenPopup = {setShowModalEditMesa}
            >
                <AddMesa
                    mesa={selectMesa}
                    id_sala={selectSala.id}
                    handleLoad={handleLoad}
                />
            </Popup>
        }
        {showModalConfig &&
            <Popup
                largo="sm"
                title = 'Seleccionar el tipo de servicio'
                openPopup = {showModalConfig}
                setOpenPopup = {setShowModalConfig}
            >
                <ConfigMesa
                    mesa={selectMesa}
                    id_sala={selectSala.id}
                    handleLoad={handleLoad}
                    closeModal = {()=>{setShowModalConfig(false)}}
                />
            </Popup>
        }
        {showModalQr &&
            <Popup
                largo="sm"
                title = 'Generar Código QR'
                openPopup = {showModalQr}
                setOpenPopup = {setShowModalQr}
            >
                <CodigoQR
                    mesa={selectMesa}
                    closeModal = {()=>{setShowModalQr(false)}}
                />
            </Popup>
        }
        {showModalReserva &&
            <Popup
               largo="sm"
               title = 'Registro de Reserva'
               openPopup = {showModalReserva}
               setOpenPopup = {setShowModalReserva}
            >
               <ModalReservas
                  data={selectMesa}
                  onlistTable={() => {cargarMesas(selectSala.id)}}
                  close={()=>{setShowModalReserva(false)}}
               />
            </Popup>
        }

      </Protected>
   )

}
